import Chip from '@mui/material/Chip'
import makeStyles from '@mui/styles/makeStyles'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import { SORT_CLICKS } from 'lib/constants'
import { today } from 'lib/utils'
import { useRouter } from 'next/router'
import React from 'react'

export const useStyles = makeStyles(theme => {
  const color = theme.palette.getContrastText(theme.palette.primary.main)

  return {
    root: {
      backgroundColor: theme.palette.primary.main,
      color,
      display: 'flex',
      flexDirection: 'column'
    },
    chips: {
      marginBottom: '8px',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'

    },
    chip: {
      color,
      borderColor: color
    }
  }
})

export default function CalendarSearchToolbar ({ onClick }) {
  const classes = useStyles()
  const router = useRouter()

  const handleClick = day => {
    let date

    onClick()
    switch (day) {
      case 'vorgestern':
        date = subDays(today(), 2)
        break
      case 'gestern':
        date = subDays(today(), 1)
        break
      default:
        date = today()
    }
    router.push({
      pathname: '/search',
      query: `date=${format(date, 'dd.MM.yyyy')}&sort=${SORT_CLICKS}`
    }).then(() => window.scrollTo(0, 0))
  }

  return (
    <Toolbar className={classes.root}>
      <Typography variant='h6'>Suche nach Datum</Typography>
      <div className={classes.chips}>
        <Chip label='Heute' variant='outlined' className={classes.chip} clickable onClick={() => handleClick('heute')} data-test='search-today' />
        <Chip label='Gestern' variant='outlined' className={classes.chip} clickable onClick={() => handleClick('gestern')} />
        <Chip label='Vorgestern' variant='outlined' className={classes.chip} clickable onClick={() => handleClick('vorgestern')} />
      </div>
    </Toolbar>
  )
}
